import React           from 'react';
import PriceMatrixBody from './PriceMatrixBody';
import PriceMatrixHead from './PriceMatrixHead';

const PriceMatrix = (props) => {
  const { leadTimes } = props;
  return (
    <div className="table-responsive">
      <table className="table table-bordered table-sm table-price-matrix">
        <PriceMatrixHead leadTimes={leadTimes} />
        <PriceMatrixBody {...props} />
      </table>
    </div>
  );
};

export default PriceMatrix;
